var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E9530D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.091 13.657a.858.858 0 0 0-.858.865v7.868c0 2.14-1.729 3.877-3.845 3.877H5.56c-2.122 0-3.845-1.743-3.845-3.877v-7.996a.858.858 0 1 0-1.716 0v7.996c0 3.095 2.498 5.607 5.561 5.607h18.827c3.07 0 5.561-2.518 5.561-5.607v-7.868a.862.862 0 0 0-.858-.865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.37 21.128a.86.86 0 0 0 .605.256.834.834 0 0 0 .603-.256l5.454-5.497a.867.867 0 0 0 0-1.224.85.85 0 0 0-1.214 0l-3.985 4.024V.88a.858.858 0 1 0-1.716 0v17.55l-3.992-4.024a.85.85 0 0 0-1.214 0 .867.867 0 0 0 0 1.224l5.46 5.497z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.d356d2296af12e216358425c856b9575.svg";
export { ForwardRef as ReactComponent };